import {
  DayOfWeek,
  IImage,
  IOrganizationAdmin,
  IOrganizationContactPerson,
  IRole,
  OrganizationContext,
} from '@boma/client-shared';

export interface IProfile {
  id: string;
  firstName: string;
  surname: string;
  entities?: IProfileEntity[];
  roles: IRole[];
  createdAt: Date;
  updatedAt: Date;
}

export class IProfileEntity {
  id: string;
  name: string;
  permissions: string[];
  context: string;
  logo: string;
  type: OrganizationContext;
  country?: string;

  constructor(init: Partial<IProfileEntity>) {
    Object.assign(this, init);
  }

  hasPermission(permission: string): boolean {
    return this.permissions.some((x) => x === permission);
  }
}

export class IProfileEntityDetail extends IProfileEntity {
  sector: string;
  registeredName: string;
  tradingName: string;
  registrationNumber: string;
  taxNumber: string;
  contactNumber: string;
  physicalAddressLineOne: string;
  physicalAddressLineTwo: string;
  physicalAddressCity: string;
  postalAddressLineOne: string;
  postalAddressLineTwo: string;
  postalAddressCity: string;
  postalAddressPostalCode: number;
  yearEndDate: string;
  weekStart: DayOfWeek;
  webAddress: string;
  countryId: string;
  images: IImage[];
  entityContactPersons: IOrganizationContactPerson[];
  administrators: IOrganizationAdmin[];
  websiteAddress: string;

  constructor(init: Partial<IProfileEntityDetail>, base: IProfileEntity) {
    super(base);
    Object.assign(this, init);
  }
}
